import { render, staticRenderFns } from "./AlumniView.vue?vue&type=template&id=761a2958"
import script from "./AlumniView.vue?vue&type=script&lang=js"
export * from "./AlumniView.vue?vue&type=script&lang=js"
import style0 from "./AlumniView.vue?vue&type=style&index=0&id=761a2958&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports